<template>
  <g stroke="null" fill-rule="evenodd" fill="none">
    <path d="M.063.063h19.875v19.875H.063V.063z" />
    <path
      d="M7.516 14.14H3.375V5.86h4.14v8.28zm1.656-8.28v8.28l7.453 4.141V1.72l-7.453 4.14z"
      fill-rule="nonzero"
      :fill="color"
    />
  </g>
</template>

<script>
export default {
  props: {
    color: {
      type: String,
      required: true
    }
  }
};
</script>
